import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal/modal.component';
import { MdDatepickerModule } from '@angular/material';

import { EmailService } from '../../services/email.service';
import { SlackService } from '../../services/slack.service';
import { NotificationService } from '../../services/notification.service';

import { OfferExpectation, OfferPersonal } from '../../interfaces/offer.interface';

@Component({
	selector: 'app-offer-modal',
	templateUrl: './offer-modal.component.html',
	styleUrls: ['./offer-modal.component.css']
})
export class OfferModalComponent implements OnInit {
	@ViewChild('offerModal') public offerModal: ModalDirective;

	offerExpectationForm: FormGroup;
	offerPersonalForm: FormGroup;
	currentDate = new Date();

	constructor(
		private formBuilder: FormBuilder,
		private emailService: EmailService,
		private slackService: SlackService,
		private notificationService: NotificationService
	) {
		this.offerExpectationForm = this.formBuilder.group({
			arrival: [null, Validators.required],
			departure: [null, Validators.required],
			adult: [null, Validators.required],
			child: [null],
			baby: [null]
		});
		this.offerPersonalForm = this.formBuilder.group({
			name: [null, Validators.required],
			phone: [36, [Validators.required, Validators.minLength(10)]],
			email: [null, [Validators.required, Validators.email]],
			message: [null],
			promotion: [false],
			legal: [false, Validators.pattern('true')],
			time: [null]
		});
	}

	ngOnInit() { }

	public show(expectation: OfferExpectation): void {
		this.offerExpectationForm.reset();
		this.offerExpectationForm.patchValue(expectation);
		this.offerModal.show();
	}

	public send(expectation: OfferExpectation, personal: FormGroup): void {
		let personalInfo: OfferPersonal = null;
		if (this.formsValid(expectation, personal)) {
			personalInfo = personal.value;
			personalInfo.time = new Date().getTime();
			this.emailService.sendOffer(expectation, personalInfo).subscribe(res => {
				// console.log('Success', res);
				this.notificationService.show('Ajánlatkérés küldése sikeres!');
			}, error => {
				// console.log('Error', error);
				this.notificationService.show('Ajánlatkérés küldése SIKERTELEN!');
			});
			this.slackService.sendOffer(expectation, personalInfo);
			this.offerExpectationForm.reset();
			this.offerPersonalForm.reset();
			this.offerModal.hide();
		}
	}

	private formsValid(expectation: OfferExpectation, personal: FormGroup): boolean {
		if (!expectation.arrival) {
			this.notificationService.show('Érkezés dátumának megadása kötelező!');
			return false;
		}
		else if (!expectation.departure) {
			this.notificationService.show('Távozás dátumának megadása kötelező!');
			return false;
		}
		else if (!expectation.adult) {
			this.notificationService.show('Felnőttek számának megadása kötelező!');
			return false;
		}
		else if (!personal.controls['name'].valid) {
			this.notificationService.show('Név megadása kötelező!');
			return false;
		}
		else if (!personal.controls['phone'].valid) {
			this.notificationService.show('Telefonszám megfelelő formátumú megadása kötelező!');
			return false;
		}
		else if (!personal.controls['email'].valid) {
			this.notificationService.show('E-mail cím megfelelő formátumú megadása kötelező!');
			return false;
		}
		else if (!personal.controls['legal'].valid) {
			this.notificationService.show('Adatkezelési szabályzat elfogadása kötelező!');
			return false;
		}
		else {
			return true;
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/offer-modal/offer-modal.component.ts